exports = module.exports = require("../../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Checkboxes-module__wrapper___1Z2Ju{display:grid;gap:.75rem;align-items:center}", ""]);

// exports
exports.locals = {
	"wrapper": "Checkboxes-module__wrapper___1Z2Ju"
};